import { render, staticRenderFns } from "./DashboardTachographHistoryView.vue?vue&type=template&id=3ec05736&scoped=true&"
import script from "./DashboardTachographHistoryView.vue?vue&type=script&lang=js&"
export * from "./DashboardTachographHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTachographHistoryView.vue?vue&type=style&index=0&id=3ec05736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec05736",
  null
  
)

/* custom blocks */
import block0 from "./DashboardTachographHistoryView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports